import { isNil } from 'lodash';
import { createAction } from 'redux-actions';

import * as applicationDateActionsAutomaticLanding from './applicationDataAutomaticLanding.module';
import * as applicationDataActionsBuy from './applicationDataBuy.module';
import * as applicationDataCollegeContribute from './applicationDataCollegeContribute.module';
import * as applicationDataCollegeDistribute from './applicationDataCollegeDistribute.module';
import * as applicationDataActionsExchange from './applicationDataExchange.module';
import * as applicationDataLanding from './applicationDataLanding.module';
import * as applicationDataActionsRecurringBuy from './applicationDataRecurringBuy.module';
import * as applicationDataActionsIRAAutoMax from './applicationDataIRAAutoMax.module';
import * as applicationDataActionsSell from './applicationDataSell.module';
import * as applicationDataActionsAutomaticSell from './applicationDataAutomaticSell.module';
import * as applicationDataActionsAppBuy from './applicationDataAppBuy.module';
import * as applicationDataActionsAppSell from './applicationDataAppSell.module';
import * as applicationDataRothConversion from './applicationDataRothConversion.module';
import * as applicationDataActionsQCDEntry from './applicationDataQCDEntry.module';
import * as applicationDataActionsQCDLanding from './applicationDataQCDLanding.module';

import { APP_LOADED } from '../../../settings/settings';
import {
  AUTOMATIC_LANDING,
  AUTOMATIC_SELL_TRANSACTION,
  BUY_TRANSACTION,
  APP_BUY_TRANSACTION,
  APP_SELL_TRANSACTION,
  COLLEGE_CONTRIBUTE_TRANSACTION,
  COLLEGE_DISTRIBUTE_TRANSACTION,
  COLLEGE_EXCHANGE_TRANSACTION,
  EXCHANGE_TRANSACTION,
  TRANSACTION_LANDING,
  RECURRING_BUY_TRANSACTION,
  IRA_AUTOMAX_TRANSACTION,
  QCD_ENTRY,
  QCD_TRANSACTION,
  RECURRING_EXCHANGE_TRANSACTION,
  RECURRING_BUY_TRANSACTION_EDIT,
  SELL_TRANSACTION,
  ROTH_CONVERSION,
  transactionType,
  isTransactionLanding,
} from '../../../utils/transactions-util';
import { action } from 'typesafe-actions';

const appDataObject = {
  [AUTOMATIC_LANDING]: applicationDateActionsAutomaticLanding,
  [BUY_TRANSACTION]: applicationDataActionsBuy,
  [RECURRING_BUY_TRANSACTION]: applicationDataActionsRecurringBuy,
  [RECURRING_BUY_TRANSACTION_EDIT]: applicationDataActionsRecurringBuy,
  [IRA_AUTOMAX_TRANSACTION]: applicationDataActionsIRAAutoMax,
  [SELL_TRANSACTION]: applicationDataActionsSell,
  [AUTOMATIC_SELL_TRANSACTION]: applicationDataActionsAutomaticSell,
  [APP_BUY_TRANSACTION]: applicationDataActionsAppBuy,
  [APP_SELL_TRANSACTION]: applicationDataActionsAppSell,
};

// separate lines to avoid merge conflict until fully merged
appDataObject[COLLEGE_CONTRIBUTE_TRANSACTION] =
  applicationDataCollegeContribute;
appDataObject[COLLEGE_DISTRIBUTE_TRANSACTION] =
  applicationDataCollegeDistribute;
appDataObject[COLLEGE_EXCHANGE_TRANSACTION] = applicationDataActionsExchange;
appDataObject[EXCHANGE_TRANSACTION] = applicationDataActionsExchange;
appDataObject[TRANSACTION_LANDING] = applicationDataLanding;
appDataObject[RECURRING_EXCHANGE_TRANSACTION] = applicationDataActionsExchange;
appDataObject[ROTH_CONVERSION] = applicationDataRothConversion;
appDataObject[QCD_ENTRY] = applicationDataActionsQCDEntry;
appDataObject[QCD_TRANSACTION] = applicationDataActionsQCDLanding;

let transactionActions;
if (isNil(transactionType())) {
  transactionActions = {
    ...applicationDataActionsBuy,
    ...applicationDataActionsRecurringBuy,
    ...applicationDataActionsSell,
  };
} else {
  transactionActions = appDataObject[transactionType()];
}

if (isTransactionLanding()) {
  transactionActions = appDataObject[TRANSACTION_LANDING];
}

export default function applicationData(
  state = {
    hasFailed: false,
    isLoading: false,
    isLoaded: false,
  },
  { type }
) {
  switch (type) {
    case `${APP_LOADED}_PENDING`:
      return {
        ...state,
        hasFailed: false,
        isLoading: true,
      };
    case `${APP_LOADED}_FULFILLED`:
      return {
        ...state,
        hasFailed: false,
        isLoading: false,
        isLoaded: true,
      };
    case `${APP_LOADED}_REJECTED`:
      return {
        ...state,
        hasFailed: true,
        isLoading: false,
      };
    default:
      return state;
  }
}

export const setAppLoading = () => {
  const action = createAction(`${APP_LOADED}_PENDING`)(true);
  return (dispatch) => {
    dispatch(action);
  };
};

export const initAppLoad = () => action(`${APP_LOADED}_PENDING`);

export const appDataActions = {
  setAppLoading,
  ...transactionActions,
};
